import artifact from '$houdini/artifacts/MergeCustomers'
import { MutationStore } from '../runtime/stores/mutation'

export class MergeCustomersStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
